export function toQueryString(obj:IObjectParam):string {    
    return toQueryStringHelper(obj, '?')
}

export function toPartialQueryString(obj:IObjectParam):string {
    return toQueryStringHelper(obj, '&')
}

function toQueryStringHelper(obj:IObjectParam, firstChar:string):string {
    if (!obj || typeof obj !== "object" || !Object.keys(obj).length)  {
        return '';
    }

    const objList = Object.keys(obj).map((key:string) => {
        if (obj[key] === undefined || obj[key] === null || obj[key] === '' || (Array.isArray(obj[key]) && !obj[key].length)) {
            return ''
        }
        
        return `${key}=${obj[key].toString()}`
    })

    const objListFiltered = objList.filter((k:string) => {
        return k !== ''
    })

    if (!objListFiltered.length) {
        return ''
    }

    return firstChar + objListFiltered.join('&')
}

interface IObjectParam {
    [key:string]:any
}
